import React from 'react';
import { AppPaper } from '../../layout/appPaper';
import { useTheme, useMediaQuery, Typography } from '@mui/material';
import { Profile } from '../../models/profile';
import { ColorPalette } from '../../styles/constants';

interface Props {
  profile: Profile;
}

export function ProfileInfo({ profile }: Props): JSX.Element {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppPaper isMobile={isMobile} sx={{ height: '100%' }}>
      <Typography variant="h1" sx={{ mb: 2, mt: 3 }}>
        {profile.name} ({profile.userName})
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <span style={{ color: ColorPalette.RAISIN_BLACK }}>ID: </span>
        {profile.internalId}
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <span style={{ color: ColorPalette.RAISIN_BLACK }}>Position: </span>
        {profile.jobTitle}
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <span style={{ color: ColorPalette.RAISIN_BLACK }}>E-mail: </span>
        {profile.email}
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <span style={{ color: ColorPalette.RAISIN_BLACK }}>Department: </span>
        {profile.department}
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <span style={{ color: ColorPalette.RAISIN_BLACK }}>Reports to: </span>
        {profile.managerName}
      </Typography>
      <Typography sx={{ mb: 4 }}>
        <span style={{ color: ColorPalette.RAISIN_BLACK }}>Location: </span>
        {profile.location}
      </Typography>
    </AppPaper>
  );
}
